import React from 'react'
import TiffinManagementSystem from './TiffinManagementSystem1';
import Footer from "../Componet/Footer";
import UserNavbar from './UserNavbar';
function Record() {
  return (
    <div>
        <UserNavbar />
        <div>
  
        <TiffinManagementSystem/> 

        </div>
         
          <Footer/>
    </div>
  )
}

export default Record
